import { render, staticRenderFns } from "./AdminExamSettingsCriteriaGrid.vue?vue&type=template&id=13df97f2"
import script from "./AdminExamSettingsCriteriaGrid.vue?vue&type=script&lang=js"
export * from "./AdminExamSettingsCriteriaGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports